import { useCallback, useContext, useMemo } from 'react';
import { FocusTrap } from '@core/components/FocusTrap';
import { ModalContext } from './ModalContext';
/**
 *
 */
export const ModalFocusTrap = ({ children }) => {
    const { disableFocusTrap, titleId } = useContext(ModalContext);
    const onEnter = useCallback((container) => {
        Array.from(container.parentElement?.children ?? []).forEach((e) => e.setAttribute('aria-hidden', 'true'));
        container.setAttribute('aria-hidden', 'false');
    }, []);
    const onExit = useCallback((container) => {
        Array.from(container.parentElement?.children ?? []).forEach((e) => e.removeAttribute('aria-hidden'));
    }, []);
    const options = useMemo(() => ({
        clickOutsideDeactivates: false,
    }), []);
    return !disableFocusTrap ? (<FocusTrap options={options} onEnter={onEnter} onExit={onExit} role="dialog" aria-labelledby={titleId}>
      {children}
    </FocusTrap>) : (<div>{children}</div>);
};
